import {get, post, postParams} from '@/utils/axios/axios.js';

const active ={
  // main.vue中的接口
  entry: (url, data) => post(url, data),
  getPropInfo: (url, data) => post(url, data),
  // actiev.vue的接口----wheel,vue的接口
  getWheel: (url, params) => get(url, params),
  wheel: (url, data) => post(url, data),
  // mission.vue的接口
  getMission: (url, data) => post(url, data),
  missionAward: (url, data) => post(url, data),
  // missiontwo.vue的接口
  getGameByIdCompat: (url, params) => get(url, params),
  // conversion.vue的接口
  getConversion: (url, data) => post(url, data),
  convertDetail: (url, data) => post(url, data),
  checkinList: (url, data) => get(url, data),
  checkinAndAward: (url, data) => post(url, data),
  convert: (url, data) => post(url, data),
  // missionAndRainking.vue接口
  getCheckInInfo: (url, data) => post(url, data),
  checkInDaily: (url, data) => post(url, data),
  receiveAward: (url, data) => post(url, data),
  // gameList.vue接口
  subscribeList: (url, data) => post(url, data),
  getGamesByIds: (url, data) => post(url, data),
  // paradiseAppt.vue接口
  subscribeInfo: (url, data) => get(url, data),
  subscribe: (url, data) => post(url, data),
  conditionAward: (url, data) => post(url, data),
  award: (url, data) => post(url, data),
  cancelSubscribe: (url, data) => post(url, data),
  // 信息展示接口 主推-介绍、特色模块
  gameDesc: (url, params) => get(url, params),
  // moreInf.vue接口 主推-更多消息模块
  link: (url, params) => get(url, params),
  // luckDraw.vue接口 主推-抽奖模块
  wheelRecord: (url, params) => get(url, params),
  // gameTop.vue接口 主推-主推模块
  getGame: (url, params) => get(url, params),
  booking: (url, params) => get(url, params),
  bookingAward: (url, params) => get(url, params),
  // task.vue接口 主推-任务模块
  changeMissionState: (url, params) => get(url, params),
  // share.vue接口 主推-分享模块
  shareInfo: (url, params) => get(url, params),
  shareSignal: (url, params) => get(url, params),
  shareAward: (url, params) => get(url, params),
  // recommend.vue接口 主推-分享上传中转信息
  shareSetData: (url, data) => post(url, data),
  bindBySponsorUuid: (url, params) => get(url, params),
  // invitationCode.vue接口 主推-邀请码
  bindByInvitationCode: (url, params) => get(url, params),
  getInvitationCode: (url, params) => get(url, params),
  getAnalysePoint: (url, params) => get(url, params),
  // sakura.vue接口 樱花校园活动
  cherryInfo: (url, params) => get(url, params),
  missionStart: (url, params) => get(url, params),
  skinList: (url, params) => get(url, params),
  helpByCode: (url, params) => get(url, params),
  getAward: (url, params) => get(url, params),
  // help.vue接口 樱花校园活动
  helpByUuid: (url, data) => get(url, data),
  // 社区招募活动
  appGameCircleApplyList: (url, data) => get(url, data), // 获取可申请游戏圈列表
  addCircleLeaderApply: (url, data) => post(url, data), // APP-H5-保存圈主申请表单
  rankingList: (url, params) => get(url, params), // APP-H5-获取用户列表
  qualified: (url, data) => get(url, data), // APP-H5-查询用户资格
  searchUser: (url, data) => get(url, data), // 搜索用户
  updateFollow: (url, data) => post(url, data), // 关注或取消关注
  // 获取分享域名接口
  getShareCsvByLocationId: (url, data) => get(url, data),
  /* 红包拉新活动接口 */
  // 获取顶部滚动信息
  getScrollInfo: (url, data) => get(url, data),
  // 获取邀请码
  getShareCode: (url, data) => get(url, data),
  // 通过邀请码绑定邀请关系
  bindByShareCode: (url, data) => get(url, data),
  // 获取红包余额、提现金额
  getAmount: (url, data) => get(url, data),
  // 获取提现码
  getWithdrawCode: (url, data) => get(url, data),
  // 获取提现记录
  getWithdraw: (url, data) => get(url, data),
  // 保存微信号
  getAccount: (url, data) => get(url, data),
  // 获取我收到的红包
  getEnvelopeReached: (url, data) => get(url, data),
  // 获取我邀请的好友
  getEnvelopeMission: (url, data) => get(url, data),
  // 获取红包记录
  getEnvelopeOpened: (url, data) => get(url, data),
  // 打开红包
  getEnvelopeOpen: (url, data) => get(url, data),
  // 通过uuid绑定邀请关系
  bindByUuid: (url, data) => get(url, data),
  // 获取可提现种类
  getWithdrawTypeList: (url, data) => get(url, data),
  // 获取大奖展示列表
  getAwardDisplayList: (url, data) => get(url, data),
  // 获取分享奖励列表
  getCheckinShareMissionList: (url, data) => get(url, data),
  // 设置分享天数
  setShareCheckInDay: (url, data) => post(url, data),
  // 领取分享奖励
  getShareAward: (url, data) => post(url, data),
  // 获取组队活动个人信息
  getTeamSkinInfo: (url, data) => get(url, data),
  // 创建队伍
  getTeamSkinTeamCreate: (url, data) => post(url, data),
  // 获取队伍信息
  getTeamSkinTeamInfo: (url, data) => get(url, data),
  // 解散队伍
  teamSkinTeamBreak: (url, data) => post(url, data),
  // 加入队伍
  teamSkinTeamJoin: (url, data) => post(url, data),
  // 打开盲盒
  teamSkinWheel: (url, data) => post(url, data),
  // 樱花校园盒子
  uploadFile: (url, data) => post(url, data),
  // 获取首页存档列表
  sukuraBox: (url, data) => get(url, data),
  // 首页栏目筛选显示
  sukuraBoxColumn: (url, data) => get(url, data),
  // 乐园用户信息添加
  sukuraBoxSyncUser: (url, data) => post(url, data),
  // 获取存档标签
  sukuraBoxTags: (url, data) => get(url, data),
  // 存档表单提交
  sukuraBoxStore: (url, data) => post(url, data),
  // 我的收藏存档
  sukuraBoxCollect: (url, data) => get(url, data),
  // 我的存档(包括我的存档详情页)
  sukuraBoxMyArc: (url, data) => get(url, data),
  // 我的存档(包括我的存档详情页)
  sukuraBoxCancelArc: (url, data) => post(url, data),
  // 存档点赞收藏分享
  sukuraBoxOpArc: (url, data) => post(url, data),
  // 存档推荐
  sukuraBoxRecommend: (url, data) => get(url, data),
  // 存档详情
  sukuraBoxArcDetail: (url, data) => get(url, data),
  // 验证存档id是否有效
  storeGameArcIdCheck: (url, data) => post(url, data),
  // 获取存档规则
  sukuraBoxPaper: (url, data) => get(url, data),
  // 获取存档规则
  sukuraBoxSendFeedback: (url, data) => post(url, data),
  // 获取樱花校园轮播列表
  getSakuraPushData: (url, data) => get(url, data),
};

export default active;
